/// Path-based navigation primitive.
///
/// Lives in `shared` so that any FSD layer above shared (entities, features,
/// widgets, pages) can request a navigation without depending on the `app`
/// layer that owns the current route state. The state itself is updated by
/// `app/router.svelte` listening to the `popstate` event (browser back/forward)
/// and the `navigate` custom event this function emits for in-app navigations.
///
/// Production hosting (CloudFront + S3) and the local nginx container both
/// serve `index.html` as a SPA fallback for unknown paths, so deep links like
/// `/firms/abc123` work on full page loads as well.

export const NAVIGATE_EVENT = 'lpcrm:navigate';

function currentPath(): string {
  if (typeof window === 'undefined') return '/';
  return window.location.pathname || '/';
}

export function navigate(path: string): void {
  if (typeof window === 'undefined') return;
  const target = path.startsWith('/') ? path : `/${path}`;
  if (currentPath() === target) {
    // Re-navigating to the same path is a "refresh this view" intent;
    // dispatch the custom event manually so subscribers re-parse the route.
    window.dispatchEvent(new CustomEvent(NAVIGATE_EVENT));
    return;
  }
  window.history.pushState({}, '', target);
  window.dispatchEvent(new CustomEvent(NAVIGATE_EVENT));
}
